import type { ObjectStorage } from './fake-storage';

/**
 * E2E-test-only instrumentation: wraps a storage backend so a Playwright
 * test can arm "the next save fails" from `window`, to exercise the
 * non-conflict save-failure path (Story 2, Acceptance 7) end-to-end. The
 * store-level revert/reject logic itself is already unit-tested directly
 * (app/tests/store/cellar-store.test.ts); this only proves the UI wires it
 * up correctly. Inert unless a test explicitly calls `armSaveFailure()`.
 */
export interface DebugStorageHooks {
  armSaveFailure(): void;
}

declare global {
  interface Window {
    __caveDebug?: DebugStorageHooks;
  }
}

export function withDebugHooks(inner: ObjectStorage): ObjectStorage {
  let failNextPut = false;

  if (typeof window !== 'undefined') {
    window.__caveDebug = {
      armSaveFailure() {
        failNextPut = true;
      },
    };
  }

  return {
    get: (path) => inner.get(path),
    list: (prefix) => inner.list(prefix),
    put: (path, value, options) => {
      if (failNextPut) {
        failNextPut = false;
        return Promise.reject(new Error('network error (simulated by an e2e test)'));
      }
      return inner.put(path, value, options);
    },
  };
}
